import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { copyInputToClipboard } from '../../../../utils/react-utils';

const CopyTextInput = function CopyTextInput(props) {
    const { copy } = props;
    const input = useRef(null);

    function handleClick() {
        copyInputToClipboard(input.current);
    }

    return (
        <div className={styles['copy-text-input']}>
            <input ref={input} className="input" type="text" value={`https://${copy}`} readOnly />
            <button className="button is-info is-outlined" onClick={handleClick} type="button">Copy link</button>
        </div>
    );
};

CopyTextInput.propTypes = {
    copy: PropTypes.string.isRequired,
};

CopyTextInput.defaultProps = {
};

export default CopyTextInput;
